import { forwardRef, useId, type InputHTMLAttributes, type ReactNode, type SelectHTMLAttributes } from "react";
import { cx } from "./cx";

type Rotulado = { rotulo: ReactNode; ajuda?: ReactNode; erro?: string | null };

function Moldura({ id, rotulo, ajuda, erro, children }: Rotulado & { id: string; children: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <label htmlFor={id} className="text-meta font-medium text-texto-3">{rotulo}</label>
      {children}
      {erro ? (
        <p id={`${id}-erro`} role="alert" className="text-meta text-alerta">{erro}</p>
      ) : ajuda ? (
        <p id={`${id}-ajuda`} className="text-meta text-texto-3">{ajuda}</p>
      ) : null}
    </div>
  );
}

export const Campo = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & Rotulado>(function Campo(
  { rotulo, ajuda, erro, className, id, ...resto },
  ref,
) {
  const auto = useId();
  const i = id ?? auto;
  return (
    <Moldura id={i} rotulo={rotulo} ajuda={ajuda} erro={erro}>
      <input ref={ref} id={i} aria-invalid={erro ? true : undefined}
        aria-describedby={erro ? `${i}-erro` : ajuda ? `${i}-ajuda` : undefined}
        className={cx("campo", className)} {...resto} />
    </Moldura>
  );
});

export const Selecao = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement> & Rotulado>(function Selecao(
  { rotulo, ajuda, erro, className, id, children, ...resto },
  ref,
) {
  const auto = useId();
  const i = id ?? auto;
  return (
    <Moldura id={i} rotulo={rotulo} ajuda={ajuda} erro={erro}>
      <select ref={ref} id={i} aria-invalid={erro ? true : undefined} className={cx("campo pr-8", className)} {...resto}>
        {children}
      </select>
    </Moldura>
  );
});
